import * as React from 'react';

// Hooks
import {
  useTranslation,
  config,
  isWebBridgeSupported,
} from '@shopee-user/platform';

// Utils
import { constants } from '@shopee-user/business-customization-logic';
import { forwardOrAppendAuthParamsIfNotExist } from '@shopee-user/authentication-utils';

import styles from './style.scss';
import {
  BusinessTarget,
  BusinessTargetConfig,
  EnvConfig,
  LocaleDomainSuffixConfig,
} from '@shopee-user/global';
import {
  isFeatureEnabled as isStaticFeatureEnabled,
  Feature as StaticFeature,
} from '@shopee-user/static-feature-toggle';

export default function AltLoginLink() {
  const I18n = useTranslation();
  const preventFormSubmitOnEnter = (
    event: React.KeyboardEvent<HTMLAnchorElement>
  ) => {
    // prevent pressing enter key from submitting form while link is focused
    if (event.key === 'Enter') {
      event.stopPropagation();
    }
  };

  return (
    <div className={styles.altLoginLink}>
      {I18n.tNode('msg_auth_alt_main_log_in', {
        alt_login_link: (
          <a
            className={styles.link}
            href={(() => {
              const otherTarget = BusinessTarget.Spx;
              // Use proxy only if not in app and feature is enabled
              const useProxy =
                !isWebBridgeSupported() &&
                isStaticFeatureEnabled(
                  StaticFeature.LoginUseProxyDomain,
                  false
                );
              const { domain } = (() => {
                if (useProxy) {
                  const envPrefix = EnvConfig[config.ENV].subDomainPrefix;
                  const cidSuffix = LocaleDomainSuffixConfig[config.LOCALE];
                  // Use shared accounts domain with main proxy path
                  return {
                    domain: `https://account.${envPrefix}spx.${cidSuffix}`,
                  };
                }
                return {
                  domain: BusinessTargetConfig[otherTarget].getDomain(
                    config.ENV,
                    config.LOCALE
                  ),
                };
              })();
              return forwardOrAppendAuthParamsIfNotExist(
                `${domain}${constants.AUTHENTICATION_ENTRY_URL}`
              );
            })()}
            onKeyDown={preventFormSubmitOnEnter}
          >
            {I18n.t('label_auth_alt_log_in_here')}
          </a>
        ),
      })}
    </div>
  );
}
